var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendMessageActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6267 12.4903C20.9257 12.3109 21.1118 11.9871 21.1118 11.6346C21.1118 11.251 20.8914 10.9013 20.5448 10.7349L4.42955 2.9978C4.05959 2.82018 3.61839 2.88575 3.31646 3.16322C3.01452 3.4407 2.91304 3.87384 3.06044 4.25599L5.85414 11.4989C5.84809 11.5433 5.84496 11.5887 5.84496 11.6347C5.84496 11.6807 5.84808 11.726 5.85412 11.7704L3.06044 19.0133C2.91304 19.3954 3.01452 19.8286 3.31645 20.106C3.61839 20.3835 4.05959 20.4491 4.42955 20.2715L20.5291 12.5419C20.5626 12.5265 20.5952 12.5092 20.6267 12.4903ZM15.7222 10.6361L5.83654 5.8899L7.66723 10.6361H15.7222ZM15.7219 12.6333H7.66717L5.83654 17.3794L15.7219 12.6333Z",
    fill: "#E7EAF3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageActive);
export default __webpack_public_path__ + "static/media/send-message-active.1bf52d20.svg";
export { ForwardRef as ReactComponent };